<template>
    <el-popover placement="bottom-start"
                width="300"
                trigger="hover">
        <div slot="reference" class="flex align-center">
            剩余下载额度：<span class="font-size14">
              {{MG(draftinfo.residualDownloadTraffic)}}
              </span><img src="https://assets.pfotoo.com/image/notice.svg"
                          class="margin-left-sm"
                          style="width: 12px;height: 12px;"></img>
        </div>
        <div class="padding align-center flex flex-direction">
            <div v-if="draftinfo.vipType==1">
                所有人下载投稿，均会扣除您的下载额度（导出Excel不扣额度），若超过额度，请及时充值；
            </div>
            <div v-else="">
                当前为{{VERSIONS[draftinfo.vipType]?VERSIONS[draftinfo.vipType].versionName:''}}，
                <template v-if="draftinfo.vipType==0">初始赠送{{VERSIONS[draftinfo.vipType]?MG(VERSIONS[draftinfo.vipType].downloadTraffic):''}}的免费下载额度（永久有效），
                </template>
                <template v-else="">每月有{{VERSIONS[draftinfo.vipType]?MG(VERSIONS[draftinfo.vipType].downloadTraffic):''}}的免费下载额度（下次重置时间{{resetRightsDay.month||''}}月{{resetRightsDay.day||''}}日），
                </template>
                所有人下载投稿作品，均会扣除您的下载额度（导出Excel不扣额度），若下载额度不足，请及时充值购买。
            </div>
            <router-link :to="'/checkout/buyTraffic?activityId='+draftinfo.activityId+'&activityName='+draftinfo.activityName+'&userId='+draftinfo.createBy">
                <button class="cursor bg-orange radius cu-btn margin-top-xl" style="background: linear-gradient(149deg,#ed9e3d 0%, #f5b346 93%);">充下载额度</button>
            </router-link>
        </div>
    </el-popover>
</template>
<script>
  import App from '../../util/comfun'
  export default {
    props:{
      draftinfo:{
        type:Object,
        value:null,
      },
    },
    data () {
      return {
        VERSIONS:{},
        resetRightsDay:{},
      }
    },
    methods:{
      MG:App.MG,
      init(){
        this.VERSIONS=wxlite.VERSIONS
        if(!this.draftinfo.resetRightsDay) return;
        let resetRightsDay=this.draftinfo.resetRightsDay.match(/([\d]{4})([\d]{2})([\d]{2})/)
        this.resetRightsDay= {
          year:resetRightsDay[1],
          month:resetRightsDay[2],
          day:resetRightsDay[3],
        }
      },
    },
    mounted(){
      setTimeout(()=>{
        this.init();
      },1000);
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/card/traffic-popover.vue